export class WidgetJson {
  protected model: any;

  constructor(model: any) {
    this.model = model;
  }

  shouldIncludeInOutput(fieldName: string) {
    if (this.model?.jsonObj.includeInOutputFields) {
      return this.model?.jsonObj.includeInOutputFields[fieldName] !== false;
    }
    return true;
  }
}
